import { render, staticRenderFns } from "./association_exhibition.vue?vue&type=template&id=d472c686&scoped=true"
import script from "./association_exhibition.vue?vue&type=script&lang=js"
export * from "./association_exhibition.vue?vue&type=script&lang=js"
import style0 from "./association_exhibition.vue?vue&type=style&index=0&id=d472c686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d472c686",
  null
  
)

export default component.exports